module.exports = __webpack_public_path__ + "9b6065418243c47a1a4a6b69f7b5a3a8.png";